// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WAB3hGATTSExR6oitbv1{display:inline-flex}`, "",{"version":3,"sources":["webpack://./src/design-system/components/Hint/Tooltip.module.scss"],"names":[],"mappings":"AAAA,sBACE,mBAAA","sourcesContent":[".content {\n  display: inline-flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `WAB3hGATTSExR6oitbv1`
};
export default ___CSS_LOADER_EXPORT___;
